import { Model } from 'app/model/backendmodel';

export const FLOW = '~>';
// TODO - ans - It should be in generated file from swagger.
export interface IDataFlow {
    name: string;
    properties: IDataFlowPreviewProperties | IDataFlowProperties;
}

export interface IDataFlowWranglingTypeProperties {
    sources: IDataFlowSource[];
    script: string;
    documentLocale?: string;
}

export interface IDataFlowMappingTypeProperties {
    sources: IDataFlowSource[];
    sinks: IDataFlowSink[];
    udfLibraries?: Model.DataFlowReference[];
    transformations?: ITransformation[];
    groups?: IGroup[];
    script?: string;
    scriptLines?: string[];
}

export interface IDataFlowPreviewProperties extends IDataFlowMappingTypeProperties {
    description: string;
    folder?: Model.IFolder;
    userDependencies?: IDataFlowUserDependencies;
}

export interface IDataFlowProperties {
    description: string;
    // eslint-disable-next-line
    type?: string;
    typeProperties?: IDataFlowMappingTypeProperties | IDataFlowWranglingTypeProperties;
    folder?: Model.IFolder;
}

export interface IDataFlowUserDependencies {
    linkedService: Model.LinkedServiceReference;
    paths: string[];
}

export interface IDataFlowSource {
    name: string;
    description?: string;
    dataset?: Model.DatasetReference;
    linkedService?: Model.LinkedServiceReference;
    schemaLinkedService?: Model.LinkedServiceReference;
    script?: string;
    staging?: IDataFlowStaging;
    type?: string;
    typeProperties?: Record<string, unknown>;
}

export interface IDataFlowStaging {
    linkedService: Model.LinkedServiceReference;
    folderPath: string;
}

export interface IDataFlowQuery {
    queryName: string;
    dataflowSinks: IDataFlowSink[];
}

export interface IDataFlowSink {
    name: string;
    description?: string;
    dataset?: Model.DatasetReference;
    linkedService?: Model.LinkedServiceReference;
    schemaLinkedService?: Model.LinkedServiceReference;
    script?: string;
    maxConcurrentConnections?: number;
    filePattern?: string;
    partitionFileNames?: string[];
    rowUrl?: string;
    staging?: IDataFlowStaging;
    rejectedDataLinkedService?: Model.LinkedServiceReference;
    type?: string;
    typeProperties?: Record<string, unknown>;
}

export interface ITransformation {
    name: string;
    description?: string;
    script?: string;
    linkedService?: Model.LinkedServiceReference;
    dataset?: Model.DatasetReference;
}

export interface IFlowletTransformation extends ITransformation {
    flowlet?: Model.DataFlowReference;
}

export interface IGroup extends ITransformation {
    transformations?: string[];
}

export interface ISandboxDataFlow {
    dataflow: IDataFlow;
    linkedServices: Model.LinkedServiceResource[];
    dataSets: Model.DatasetResource[];
    integrationRuntimes: Model.IntegrationRuntimeResource[];
}

export enum ContainerType {
    CONTAINER = 'container',
    FILE_SYSTEM = 'fileSystem',
    BUCKET_NAME = 'bucketName'
}
